/*
  Free Lenses — lens configurator labels (frame product pages only).
  Loaded from layout/theme.liquid on product templates "" and "customize-product".
  Display-only: it never changes prices, variants or cart properties.

  - Lens brand card priced $0 (SunberryRX): "From $0"  ->  "FREE"
    (no struck-through value here — it read like a lens-brand price comparison next to Oakley;
     the $100+ value lives in the headline / "You save" line instead)
  - Lens options priced $0 (Grey / Green / Clear):  "+ $0.00"  ->  "FREE"
  - Single Vision, while the $0 lens brand is selected:  adds "FREE"
  - Paid upgrades keep their "+ $X" add-on price untouched.
*/
(function () {
  'use strict';

  var VALUE = 110; // lens $75 + anti-reflective $35 (competitor average used for the "Over $100" headline)

  function num(text) {
    var digits = (text || '').replace(/[^0-9.]/g, '');
    return digits === '' ? null : parseFloat(digits);
  }

  function makeTag(withStrike) {
    var tag = document.createElement('span');
    tag.className = 'flc-tag';
    tag.setAttribute('aria-label', withStrike ? 'Free, normally $' + VALUE : 'Free');
    tag.innerHTML =
      (withStrike ? '<s class="flc-was" aria-hidden="true">$' + VALUE + '</s>' : '') +
      '<span class="flc-free" aria-hidden="true">FREE</span>';
    return tag;
  }

  function toggle(li, on, anchor, where, withStrike) {
    var existing = li.querySelector('.flc-tag');
    if (on && anchor) {
      if (!li.classList.contains('flc-is-free')) li.classList.add('flc-is-free');
      if (!existing) anchor.insertAdjacentElement(where, makeTag(withStrike));
    } else {
      if (li.classList.contains('flc-is-free')) li.classList.remove('flc-is-free');
      if (existing) existing.remove();
    }
  }

  function apply() {
    var lensCard = document.querySelector('.pdp-stepcard--lens');
    if (!lensCard) return;

    var freeBrandSelected = false;

    // 1) Lens brand cards
    lensCard.querySelectorAll('li.product_option_brand_value').forEach(function (li) {
      var price = li.querySelector('.option_brand_price');
      var isFree = price ? num(price.textContent) === 0 : false;
      toggle(li, isFree, li.querySelector('.value_label'), 'afterend', false);
      if (isFree && li.classList.contains('lens_name_active')) freeBrandSelected = true;
    });

    // 2) Lens options (colours)
    lensCard.querySelectorAll('li.all_brand_options').forEach(function (li) {
      var price = li.querySelector('[data-re-price-show]');
      var isFree = price ? num(price.textContent) === 0 : false;
      toggle(li, isFree, li.querySelector('.option_brand_price'), 'afterend', false);
    });

    // 3) Vision type — Single Vision is part of the free lens
    document.querySelectorAll('.pdp-stepcard--vision li.vision_type_item').forEach(function (li) {
      var isFree = freeBrandSelected && parseFloat(li.getAttribute('data-currvisionprice') || '1') === 0;
      toggle(li, isFree, li.querySelector('.richtext_regular'), 'beforeend', false);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    // setTimeout (not requestAnimationFrame) so it also runs in background tabs
    window.setTimeout(function () {
      queued = false;
      apply();
    }, 30);
  }

  function init() {
    var lensCard = document.querySelector('.pdp-stepcard--lens');
    if (!lensCard) return;
    apply();
    // the theme marks the selected lens brand after load; re-check a few times
    [300, 1000, 2500].forEach(function (ms) { window.setTimeout(apply, ms); });
    var root = lensCard.closest('.product__info-container') || document.body;
    new MutationObserver(schedule).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'data-currvisionprice']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
